export default __webpack_public_path__ + "static/desktop_5-ec6202f6912dfe2f63ef1d8727958574.webp";